import React from 'react';

export function Arrow({ rtl = false, size = 14 }: { rtl?: boolean; size?: number }) {
  return (
    <svg
      width={size}
      height={(size * 10) / 14}
      viewBox="0 0 14 10"
      fill="none"
      aria-hidden="true"
      style={rtl ? { transform: 'scaleX(-1)' } : undefined}
    >
      <path
        d="M1 5 H12 M8 1 L12 5 L8 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}

export function Spinner({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      className="spinner"
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeOpacity="0.3" strokeWidth="1.5" fill="none" />
      <path
        d="M14 8 A6 6 0 0 0 8 2"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
